/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_TeamInputs */

const en_email_team = /** @type {(inputs: Email_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recobra Team`)
};

const pt_br2_email_team = /** @type {(inputs: Email_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipe Recobra`)
};

/**
* | output |
* | --- |
* | "Recobra Team" |
*
* @param {Email_TeamInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const email_team = /** @type {((inputs?: Email_TeamInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_TeamInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_email_team(inputs)
	return pt_br2_email_team(inputs)
});